var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userAccount)?_c('div',{staticClass:"sm-settings"},[_c('div',{staticClass:"sm-wrap sm"},[_c('breadcrumbs-block',{attrs:{"crumbs":_vm.breadcrumbs}}),_c('settings-top'),_c('settings-main')],1)]):_c('sm-spinner',{attrs:{"show":!_vm.userAccount}})
}
var staticRenderFns = []

export { render, staticRenderFns }